import { absolutePath } from "./absolutePath";

const BASE_PATH = "crm/filters";

export const crmFilters = {
  configuration: () => absolutePath(`${BASE_PATH}/configuration`),
};
